import {
  BANK_CODES_FOR_ALL,
  BankCodesForAll,
  ORGANIZATION_CODES,
  OrganizationCodes,
} from '../models';

export function getBankName(bankCode: OrganizationCodes, getAlias?: boolean) {
  return getAlias
    ? ORGANIZATION_CODES[bankCode]?.replace('은행', '')
    : ORGANIZATION_CODES[bankCode] || '';
}

export function getAllBankName(bankCode: BankCodesForAll, getAlias?: boolean) {
  return getAlias
    ? BANK_CODES_FOR_ALL[bankCode]?.replace('은행', '')
    : BANK_CODES_FOR_ALL[bankCode] || '';
}
